import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceCanMoveToDepartmentPathParameters } from 'api/actions/device-can-move-to-department/device-can-move-to-department-path-parameters';
import { DeviceCanMoveToDepartmentResponse } from 'api/actions/device-can-move-to-department/device-can-move-to-department-response';

type DeviceCanMoveToDepartmentQueryParameters = Record<string, any>;

/**
 * The path of the DeviceCanMoveToDepartment action.
 */
export const deviceCanMoveToDepartmentActionPath = new SweetPath<keyof DeviceCanMoveToDepartmentPathParameters>(
  '/api/device/can-move-to-department/{deviceId}/{departmentId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized DeviceCanMoveToDepartment actions.
 */
export default function createDeviceCanMoveToDepartmentAction(axios: AxiosInstance) {
  return function deviceCanMoveToDepartmentAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: DeviceCanMoveToDepartmentPathParameters;
    query?: DeviceCanMoveToDepartmentQueryParameters;
  }) {
    const path = deviceCanMoveToDepartmentActionPath.insert(parameters);

    return axios.request<DeviceCanMoveToDepartmentResponse, DeviceCanMoveToDepartmentResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
